/** Unsent composer text, kept per conversation so switching chats never loses it. */
const PREFIX = 'volt.draft.';

export function draftKey(conversationId: string | null | undefined): string {
  return conversationId ?? 'new';
}

export function loadDraft(key: string): string {
  try {
    return window.localStorage.getItem(PREFIX + key) ?? '';
  } catch {
    return '';
  }
}

export function saveDraft(key: string, text: string): void {
  try {
    if (text.trim()) window.localStorage.setItem(PREFIX + key, text);
    else window.localStorage.removeItem(PREFIX + key);
  } catch {
    // storage may be blocked — drafts just won't persist.
  }
}
